import { render, staticRenderFns } from "./CreateCV.html?vue&type=template&id=6bf5ad0c&scoped=true&"
import script from "./CreateCV.vue?vue&type=script&lang=js&"
export * from "./CreateCV.vue?vue&type=script&lang=js&"
import style0 from "./CreateCV.scss?vue&type=style&index=0&id=6bf5ad0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5ad0c",
  null
  
)

export default component.exports